import React, { useState } from "react";
import Input from "../Elements/Input/Input";
import Button from "../Elements/Button/Button";
import { PROXY_URL } from "../../../shared/constants";
import "./Register.css";

export default Register = (props) => {

	const {
		setIsWaitingAnswer,
		errors,
		setErrors,
		existsError,
		setExistsError,
	} = props;

	const [secondName, setSecondName] = useState('');
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [password, setPassword] = useState('');
	const [phoneFieldConfirmed, setPhoneFieldConfirmed] = useState(false);
	const [activeButton, setActiveButton] = useState(true);
	const [personalData, setPersonalData] = useState(false);
	const { be } = errors;

	const handlePersonalDataChange = (value) => {
		setPersonalData(value);
		if (value && errors.personalData) {
			setErrors(prev => ({ ...prev, personalData: '' }));
		}
	};

	return (
		<div className="register">
			<div className="registerRow">
				<Input
					labelText="Фамилия Имя"
					type="text"
					placeholder="Ваша фамилия/имя"
					width="260px"
					required={true}
					setValue={setSecondName}
					errorText={errors.secondName}
					existsError={existsError}
					setExistsError={setExistsError}
					fieldName='name'
				/>
				<Input
					labelText="E-mail"
					type="text"
					placeholder="miss1265@gmail.com"
					required={true}
					width="260px"
					setValue={setEmail}
					errorText={errors.email}
					existsError={existsError}
					setExistsError={setExistsError}
					fieldName='email'
				/>
			</div>
			<div className="registerRow">
				<Input
					labelText="Телефон"
					type="text"
					placeholder="Номер телефона"
					required={true}
					width="260px"
					setValue={setPhone}
					errorText={errors.phone}
					phoneValidation={true}
					activateButton={setActiveButton}
					setPhoneFieldConfirmed={setPhoneFieldConfirmed}
					existsError={existsError}
					setExistsError={setExistsError}
					fieldName='phone'
				/>
				<Input
					labelText="Пароль"
					type="password"
					placeholder="Введите пароль"
					required={true}
					width="260px"
					setValue={setPassword}
					errorText={errors.password}
					existsError={existsError}
					setExistsError={setExistsError}
					fieldName='passwword'
				/>
			</div>
			{typeof be !== 'undefined' && <span className="beckEndError">{be}</span>}
			<Button
				type="button"
				value="Зарегистрироваться"
				fields={{ secondName, email, phone, password, personalData }}
				phoneFieldConfirmed={phoneFieldConfirmed}
				method="register"
				validate={setErrors}
				disabled={!activeButton}
				existsErrors={setExistsError}
				setIsWaitingAnswer={setIsWaitingAnswer}
			/>
			<label className="registerCheckbox">
				<Input
					type="checkbox"
					required={true}
					fieldName="personalData"
					labelText={
						<>
							Ознакомлен/на с{' '}
							<a
								href="https://melannett.ru/upload/pdf/politika-bezopasnosti-personalnykh-dannyh.pdf"
								target="_blank"
							>
								политикой обработки персональных данных
							</a>
							{' '}и публичной{' '}
							<a href="https://melannett.ru/upload/public_offer_rf.pdf" target="_blank">офертой</a>.
						</>
					}
					errorText={errors.personalData}
					setValue={handlePersonalDataChange}
					existsError={existsError}
					setExistsError={setExistsError}
				/>
				<span>
				</span>
			</label>
			<label className="registerCheckbox">
				<Input
					type="checkbox"
					required={false}
					fieldName="newsletter"
					labelText={<>Согласен/на на получение информационной и{' '}
						<a
							href={PROXY_URL + '/upload/agreement_to_marketing_mailings.pdf'}
							target="_blank"
						>
							рекламной рассылки.
						</a></>
					}
				/>
				<span>
				</span>
			</label>
		</div>
	);
}

